import {Inject, Injectable, LOCALE_ID} from "@angular/core";
import {Configuration, ConfigurationWithClientCountry} from "./configuration.model";
import {Observable, of} from "rxjs";
import {first, map, tap} from "rxjs/operators";
import {CLIENT_COUNTRY_CONFIGS} from "./configs/client-country-configs";
import {fromPromise} from "rxjs/internal/observable/innerFrom";

@Injectable({
	providedIn: "root"
})
export class ConfigurationProvider {

	private loadedConfiguration: Configuration;

	constructor(@Inject(LOCALE_ID) private locale: string) {
	}

	getConfiguration(): Observable<Configuration> {
		return this.loadedConfiguration != null ? of(this.loadedConfiguration) : this.loadConfig();
	}

	getConfigurationFor(clientCountry: string): Observable<ConfigurationWithClientCountry> {
		return this.getConfiguration().pipe(map(config => config as ConfigurationWithClientCountry), tap(config => config.clientCountryConfig = CLIENT_COUNTRY_CONFIGS[clientCountry]))
	}

	private loadConfig() {
		const configFile: string = `configuration.${this.locale}.ts`;
		let config$ = fromPromise(import(`./configs/${configFile}`)).pipe(map((c: any) => c.configuration));
		config$.pipe(first()).subscribe(config => this.loadedConfiguration = config);
		return config$;
	}
}
